module.exports = __webpack_public_path__ + "static/media/DSC_0805.f4e42966.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0805.jpg
// module id = 703
// module chunks = 0